<template>
  <section id="notFound">
    <div class="section">
      <div class="flex flex-col">
        <div>
          <h1>4<span>0</span>4</h1>
          <h2>Ooops! Page Not Found</h2>
        </div>
        <hr />
        <div>
          <p>Please make sure you re on the right URL.</p>
          <p><a href="/">Click here</a> to go back to homepage.</p>
          <p>Thank you :)</p>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
#notFound .flex {
  width: 80%;
  padding: 2rem;
  margin: 0 auto;
  border-radius: 20px;
  background: var(--secondary);
}
#notFound h1 {
  font-weight: bold;
  letter-spacing: 5px;
  font-size: 3.5rem;
  margin-bottom: 1rem;
}
#notFound h1 span {
  color: var(--primary);
}
#notFound h2 {
  color: var(--light);
  animation: notfound 5s infinite;
}
#notFound hr {
  width: 100%;
  margin-bottom: 2rem;
  border-color: var(--secondary);
}
@keyframes notfound {
  50% {
    text-shadow: 0 0 2px var(--dark);
  }
}
</style>
